import React from 'react';
import { Stack } from '@mui/material';
import { CloudOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import PullToRefresh from 'react-simple-pull-to-refresh';

export default function NetworkError({ onRefresh }) {
  const { t } = useTranslation();

  return (
    <div className="container-fluid h-100 error-container">
      <PullToRefresh onRefresh={onRefresh}>
        <Stack sx={{ alignItems: 'center' }}>
          <CloudOff style={{ fontSize: 200, color: '#7a7a7a' }} />
          <h3 style={{ color: '#7a7a7a' }}>
            {t('core.networkError')} <br />
            {t('core.pullDown')}
          </h3>
        </Stack>
      </PullToRefresh>
    </div>
  );
}
